// extracted by mini-css-extract-plugin
export default {"textbox":"_1wX639tLPtobr3EX85R9td"};